import { generalHelpers } from '@tweddle-se-team/common/helpers'
import { determineSpecificOrigin, specificOriginTitleMap } from '@/utils/specificOriginHelper'
import { productActions } from '../products'
import { searchActions } from '../search'
import { configsActions } from '../configs'
import { pageActions } from '../page'
import startCase from 'lodash/startCase'

const allowedBrands = ['lexus', 'toyota']
const DEFAULT_BRAND = 'toyota'

/**
 * This helper function initializes the brand based on the provided origin and brand.
 * It dispatches the necessary actions to the store to set the brand.
 * If no brand is specified, it defaults to "toyota".
 * It also handles specific origins that may override the brand because depending on
 * the origin (domain) we can't switch brands.
 * Additionally, only on the browser it sets the brand if not defined as the main
 * site can select the brand manually from the Navigation Bar.
 * @param {*} store
 * @returns
 */
const initializeBrand =
  store =>
  (origin = null, brand = null) => {
    const {
      search: {
        query: { filterBy }
      }
    } = store.getState()
    const selectedBrand = filterBy?.brand || ''
    const [specificOriginBrand, specificDomain] = determineSpecificOrigin(origin)

    const changeBrand = brand => {
      if (allowedBrands.includes(brand) && selectedBrand.toLowerCase() !== brand) {
        store.dispatch(productActions.SET_BRAND(startCase(brand)))
        store.dispatch(searchActions.SET_BRAND(startCase(brand)))
      }
    }
    const setShowStaticLogo = showStaticLogo => store.dispatch(configsActions.SET_SHOW_STATIC_LOGO(showStaticLogo))

    const setTitle = brand => {
      const title = specificOriginTitleMap.get(brand)
      if (title) {
        store.dispatch(pageActions.SET_TITLE(title))
      }
    }

    const setSpecificDomain = domain => store.dispatch(configsActions.SET_SPECIFIC_DOMAIN(domain))

    if (specificOriginBrand && specificOriginBrand !== selectedBrand.toLowerCase()) {
      // Specific origin has priority over brand in query params
      changeBrand(specificOriginBrand)
      // Also, showing static specific brand logo
      setShowStaticLogo(true)
      // Set specific origin title
      setTitle(specificOriginBrand)
      // Set specific origin domain
      setSpecificDomain(specificDomain)
      return specificOriginBrand
    } else if (brand && brand !== selectedBrand.toLowerCase()) {
      changeBrand(brand.toLowerCase())
      return brand.toLowerCase()
    }

    // This should only happen in the browser since the action to change the brand
    // is only visible client-side. Otherwise the brand is overriden by the server-side
    // dispatched actions.
    if (generalHelpers.isServer() && !brand && !selectedBrand) {
      changeBrand(DEFAULT_BRAND)
      return DEFAULT_BRAND
    }
    return selectedBrand
  }

const brandHelpers = {
  initializeBrand
}

export default brandHelpers
